import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Admin.css";

const AdminCard = ({ title, description, link, icon }) => {
  const cardContent = (
    <>
      {icon && <div className="admin-card-icon">{icon}</div>}
      <h3 className="admin-card-title">{title}</h3>
      <p className="admin-card-description">{description}</p>
    </>
  );

  if (link) {
    return (
      <Link to={link} className="admin-card">
        {cardContent}
      </Link>
    );
  }

  return <div className="admin-card">{cardContent}</div>;
};

export default AdminCard;

